console.log("current environment", "staging");

export const appConfig = {
  api: {
    apiUrl: 'https://edesignapi-staging.carrier.com/staging/api',
    umDashboardNavigation: 'https://www.carrierappshub.com/'
  },
  uiUrl: 'https://edesign-staging.carrier.com/licenseManager',
  apiUrl: 'https://api.carrierappshub1.com/',
  postLogOutUri: 'https://edesign-staging.carrier.com/licenseManager'
};
export default appConfig;
